// extracted by mini-css-extract-plugin
export var barbarian = "Header-module--barbarian--722f3";
export var coding = "Header-module--coding--5c542";
export var header = "Header-module--header--e1999";
export var image = "Header-module--image--13ed4";
export var maintitle = "Header-module--maintitle--2ce0a";
export var meets = "Header-module--meets--c42d6";
export var title = "Header-module--title--63cc5";